var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"claim-status",class:_vm.row.claim === 1 ? 'success' : _vm.row.claim === 2 ? 'warning' : 'error'},[_vm._v(_vm._s(_vm.row.claim_desc))])])
}
var staticRenderFns = []

export { render, staticRenderFns }